<template>
  <v-navigation-drawer
    app
    :clipped="$vuetify.breakpoint.lgAndUp"
    :value="drawer"
    :width="!mini && secondaryDrawer ? 512 : (!mini && !secondaryDrawer ? 256 : (mini && secondaryDrawer ? 312 : 56))"
    :floating="false"
    v-if="isAuthenticated && isConfigured && isSubscriptionActive"
  >
    <v-row class="fill-height" no-gutters>
      <v-navigation-drawer :value="drawer" :mini-variant.sync="mini" :floating="true">
        <v-list-item>
          <v-list-item-content v-if="!mini">
            <!--<v-list-item-title class="subtitle">Hi {{user.first_name}}!</v-list-item-title>-->
            <v-list-item-subtitle class="title">Current Bot</v-list-item-subtitle>
          </v-list-item-content>
          <v-btn class="ml-n2 my-2" large icon @click.stop="mini = !mini">
            <v-icon v-show="!mini">mdi-chevron-double-left</v-icon>
            <v-icon v-show="mini">mdi-chevron-double-right</v-icon>
          </v-btn>
          <!--<v-btn class="ma-2" large icon @click.stop="secondaryDrawerSet(!secondaryDrawer)">
            <v-icon v-show="secondaryDrawer">mdi-chevron-left</v-icon>
            <v-icon v-show="!secondaryDrawer">mdi-chevron-right</v-icon>
          </v-btn>-->
        </v-list-item>

        <v-select
          v-model="botSelected"
          :items="bots"
          item-text="first_name"
          menu-props="auto"
          label="Bot"
          class="mx-4 mb-2"
          hide-details
          v-if="bots && bots.length"
          v-show="!mini"
          return-object
          single-line
          outlined
          dense
        ></v-select>

        <v-divider></v-divider>

        <v-list nav v-if="botSelected && botSelected.active">
          <menu-item v-for="item in menu" :key="item.title" :item="item" :mini.sync="mini"></menu-item>
        </v-list>

        <p class="pa-4" v-if="!botSelected || !botSelected.active">This bot is not active, to use, activate on the bot page.</p>

        <template v-slot:append v-if="!mini">
          <div class="subtitle-2 text--secondary pl-4">THEME</div>
          <v-row class="pb-8" justify="center">
            <v-switch
              hide-details
              inset
              class="pr-4"
              v-model="$vuetify.theme.dark"
              label="Dark Theme"
            ></v-switch>
          </v-row>
        </template>
      </v-navigation-drawer>

      <v-list dense nav class="grow" v-if="secondaryDrawer">
        <v-list-item v-for="link in links" :key="link" link>
          <v-list-item-title v-text="link"></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MenuItem from "./widget/MenuItem";

export default {
  name: "App",
  data: () => ({
    mini: false,
    links: ["Home", "Contacts", "Settings"],
    menu: [
      { title: "Dashboard", icon: "mdi-view-dashboard", link: "dashboard" },
      {
        title: "Registration",
        icon: "mdi-account-details",
        link: "registration",
      },
      { title: "Groups", icon: "mdi-account-group", link: "groups" },
      { title: "Members", icon: "mdi-view-list", link: "members" },
      /*{
        title: "Members",
        icon: "mdi-account",
        links: [
          { title: "List", icon: "mdi-view-list", link: "members" },
          { title: "Map", icon: "mdi-map", link: "members-map" }
        ]
      },*/
      {
        title: "Messages",
        icon: "mdi-text-box-search-outline",
        link: "messages",
      },
      { title: "Map", icon: "mdi-map", link: "members-map" },
      { title: "Information", icon: "mdi-information", link: "information" },
      {
        title: "Actions",
        icon: "mdi-arrow-right-circle",
        links: [
          { title: "Actions", icon: "mdi-arrow-right-circle", link: "actions" },
          {
            title: "Elaborators",
            icon: "mdi-plus-box-multiple",
            link: "elaborators",
          },
        ],
      },
    ],
  }),
  computed: {
    ...mapGetters("apiAuth", ["isAuthenticated", "user"]),
    ...mapGetters("app", [
      "appName",
      "drawer",
      "secondaryDrawer",
      "selectedBot",
    ]),
    isConfigured() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        (this.user.account.subscription.paypal_subscription || this.user.account.subscription.free) &&
        this.user.account.bots &&
        this.user.account.bots.length
      );
    },
    isSubscriptionActive() {
      return (
        this.user &&
        this.user.account &&
        this.user.account.subscription &&
        this.user.account.subscription.active &&
        (this.user.account.subscription.paypal_subscription || this.user.account.subscription.free)
      );
    },
    bots() {
      return this.user && this.user.account && this.user.account.bots;
    },
    botSelected: {
      get() {
        return this.selectedBot;
      },
      set(bot) {
        this.apiUrlSet(bot.app_url || bot.api_url);
        location.reload();
      },
    },
  },
  methods: {
    ...mapActions("app", ["secondaryDrawerSet", "selectedBotSet"]),
    ...mapActions("config", ["apiUrlSet"]),
  },
  components: {
    MenuItem,
  },
};
</script>